import { styled } from "@mui/material";
import Div from "components/primitives/Div";

const AutoplayVideoRoot = styled(Div)({
  position: "relative",
  overflow: "hidden",
});

export default AutoplayVideoRoot;
